<template>

  <div class="recycle_container">
    <div class="detail_top" ref="pagesRef">
      <el-carousel :height="pagesHeight + 'px'" :autoplay="true" :interval="5000">
        <el-carousel-item v-for="(item,index) in detailImgList" :key="index">
          <img class="imgCls" :src="item.url">
        </el-carousel-item>
      </el-carousel>
    </div>

    <div class="detail_center_one">
      <div class="center_one_title">
        <div class="center_one_title_line"></div>
        <div class="center_one_title_content">闸机</div>
        <div class="center_one_title_line"></div>
      </div>

      <div class="center_one_body_current">
        <img style="width: 90%" class="oneBodyImgCls" src="../../assets/images/zj4362_center_001.png"/>
      </div>

    </div>

    <div class="detail_center_two">

      <div class="center_two_a">
        <div class="center_two_a_left"></div>
        <div class="center_two_a_right"></div>
      </div>

      <div class="center_two_b">
        <div class="center_two_b_left"></div>
        <div class="center_two_b_center">闸机</div>
        <div class="center_two_b_right"></div>
      </div>

      <div class="center_two_c">
        <div class="center_two_c_a">
          产品包括外壳机箱、机芯、摆臂、驱动器电路板、红外传感器、刷卡读头、闸机控制系统、门禁控制系统八大部分。
          <br>——系统对外采用标准电气接口，同时满足消防通道的要求。执行同一品质标准，确保运行的可靠性、稳定性和流畅性。
          <br>——适用于幼儿园、中小学等校园，企事业单位进出口考勤、门禁、消费管 理及特殊通道控制，同时也能满足车站、码头、会展、游泳馆等验票通道管 理。
        </div>
      </div>

      <div class="center_two_d">外观尺寸</div>
      <div class="center_two_e">单机芯尺寸：1200mm(长)*280mm(宽)*1050mm(高)</div>
      <div class="center_two_e">空机箱尺寸：1200mm(长)*200mm(宽)*1050mm(高)</div>

      <div class="center_other_adorn_right">
        <img class="adorn_img" src="../../assets/images/home_center_adorn.png">
      </div>

      <div class="center_two_d">应用场景</div>
      <div class="center_two_e">
        居民社区，公共场所，学校，办公场所
      </div>

      <div class="center_two_d">功能</div>
    </div>

    <div class="detail_center_three">
      <div class="center_three_body_left">
        <div class="three_body_left_left_double">声音<br/>报警</div>
        <div class="three_body_left_right">非法闯入报警、请等待对方通行、请尽快通行；</div>
      </div>

      <div class="center_three_body_right">
        <div class="three_body_right_left_double">消防<br/>功能</div>
        <div class="three_body_right_right" style="text-align: right">实现消防联动报警开闸。可实现停电断电后自动开闸（选配）；
        </div>
      </div>

      <div class="center_three_body_left">
        <div class="three_body_left_left_double">红外<br/>进出</div>
        <div class="three_body_left_right">允许使用红外进出闸机；</div>
      </div>

      <div class="center_three_body_right">
        <div class="three_body_right_left_double">拍照<br/>功能</div>
        <div class="three_body_right_right" style="text-align: right">使用IPC摄像头进行刷卡拍照；</div>
      </div>

      <div class="center_three_body_left">
        <div class="three_body_left_left_double">语音<br/>播报</div>
        <div class="three_body_left_right">用户刷卡后，可以语音播放名字；</div>
      </div>

      <div class="center_three_body_right">
        <div class="three_body_right_left_double">系统</div>
        <div class="three_body_right_right" style="text-align: right">系统采用主流Android系统，成熟、开放、开源、扩展能力强；</div>
      </div>

      <div class="center_three_body_left">
        <div class="three_body_left_left_double">人脸<br/>识别</div>
        <div class="three_body_left_right">确保真人匹配过闸，保障社区安全（选配人脸识别模块）。</div>
      </div>


    </div>

    <div class="detail_center_four">
      <img style="width: 63%;margin: 32px 0" src="../../assets/images/zj4362_center_002.png"/>
    </div>

  </div>

</template>

<script>

export default {
  data() {
    return {
      pagesHeight: "",
      detailImgList: [
        {
          url: require("../../assets/images/fk4151_top_001.png")
        }
      ]
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.pagesHeight = this.$refs.pagesRef.clientHeight;
    })

  },
}
</script>

<style lang="less" scoped>

@import "../../assets/css/detailCommonSecond";

@media screen and (max-width: 1280px) {

  .center_one_body_current {
    height: 459px;

    .oneBodyImgCls {
      width: 100%;
      height: 459px;
    }

  }

}

@media screen and (min-width: 1281px) and (max-width: 1440px) {

  .center_one_body_current {
    height: 530px;

    .oneBodyImgCls {
      width: 100%;
      height: 530px;
    }
  }

}

@media screen and (min-width: 1441px) and (max-width: 1920px) {

  .center_one_body_current {
    height: 689px;

    .oneBodyImgCls {
      width: 100%;
      height: 689px;
    }
  }
}

.center_one_body_current {
  display: flex;
  flex-direction: row-reverse;

  .oneBodyImgCls {
  }
}

</style>